// The new site's pages (staging only until launch: src/lib/homeFlag.ts). Photohawk is two products, and the site
// leads with Studio, the business (owner, 2 Nov 2026: one brand, one story, Studio first; the old split home risked
// alienating business users):
//   "/"          the home page: Photohawk Studio's story (hero, value, proof, the plans, its call to action), then ONE
//                band lower down for the Photohawk app ("Also from Photohawk"), linking /app
//   "/app"       the Photohawk app (on the App Store as "Photohawk: Friends & Family"), the iPhone app for your own
//                photos. Its legal pages stay under /personal/* (the app and the App Store link them). "/personal"
//                (its URL before) and "/?for=personal" are 301s to it.
//   "/studio"    Photohawk Studio, for photographers and event businesses: galleries, selling, Find your photos,
//                live upload, the Studio app and the Studio plans. "/events" (its URL before), "/business" (the
//                staging URL before that) and "/?for=business" are 301s to it.
//   "/download"  the Studio apps' page (Mac, iPhone/iPad; Windows later): for photographers, never the Photohawk app.

export const STUDIO_PATH = "/studio";
export const APP_PATH = "/app";
/** Where the app's own web pages live (privacy, terms, account deletion, support): public everywhere, unchanged. */
export const APP_LEGAL_BASE = "/personal";
export const DOWNLOAD_PATH = "/download";
/** The Studio page's URLs before it was named: both 301 to STUDIO_PATH where the new site is on. */
export const OLD_STUDIO_PATHS = ["/events", "/business"] as const;
/** The app page's URL before (exactly "/personal", never its legal pages below it): a 301 to APP_PATH where the new
 *  site is on. */
export const APP_ALIAS_PATHS = ["/personal"] as const;
/** The Studio page's plans (Lite, Pro, Max) and its Studio app section. */
export const STUDIO_PRICING = `${STUDIO_PATH}#pricing`;
export const STUDIO_APP = `${STUDIO_PATH}#studio-app`;
/** Studio accounts: where a new one starts (free) and where it signs in. Personal signs in inside the app. */
export const REGISTER_PATH = "/register";
export const LOGIN_PATH = "/login";
/** Where participants find their event photos (a Studio feature, open to everyone). */
export const FIND_PATH = "/find-your-photos";

/**
 * The Photohawk app in the stores: the App Store listing ("Photohawk: Friends & Family", approved November 2026; the
 * owner's URL, also server/personal-app-links.json's appStoreUrl). Every App Store link on the site uses this one
 * constant (the home page's app band, /app, the header and the footer). Android isn't out yet: the site says "Android coming
 * soon" in words and shows no Google Play badge until PERSONAL_PLAY_STORE_URL is filled.
 */
export const PERSONAL_APP_STORE_URL = "https://apps.apple.com/app/photohawk-family-friends/id6824048705";
export const PERSONAL_PLAY_STORE_URL = "";

/**
 * The Studio app's downloads, for /download. Empty until the app launches (Mac and iPhone/iPad in November 2026,
 * Windows later) and the owner gives the public links (the macOS build, the App Store listing, Windows once it
 * ships). While a link is empty, /download says "Launching November 2026" for Mac and iPhone/iPad and "Later" for
 * Windows, and its main action is Studio in the browser. Nothing links to a file that isn't public.
 */
export const STUDIO_DOWNLOADS: Record<"mac" | "ios" | "windows", string> = { mac: "", ios: "", windows: "" };
/** "Get notified when the app launches": an email to support (the Personal waitlist is Personal's own list). */
export const STUDIO_APP_NOTIFY = "mailto:support@photohawk.com?subject=Photohawk%20Studio%20app%3A%20tell%20me%20when%20it%20launches";

/** The URL's ?lang=, kept on internal links between the new pages ("" when there is none). */
export const keepLang = (search: string): string => {
  const lang = new URLSearchParams(search).get("lang");
  return lang ? `?lang=${encodeURIComponent(lang)}` : "";
};
